import React, { useMemo } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Area, AreaChart } from 'recharts';

interface PredictionData {
  timestamp: string;
  actual_energy: number;
  predicted_energy: number;
  confidence_lower: number;
  confidence_upper: number;
}

interface PredictionChartProps {
  data: PredictionData[];
  loading?: boolean;
}

const PredictionChart: React.FC<PredictionChartProps> = ({ data, loading }) => {
  if (loading) {
    return (
      <div className="h-64 flex items-center justify-center">
        <div className="animate-pulse bg-gradient-to-r from-slate-200 via-slate-300 to-slate-200 w-full h-full rounded-xl"></div>
      </div>
    );
  }

  const chartData = useMemo(() => 
    data.map(item => ({
      time: new Date(item.timestamp).toLocaleTimeString(),
      actual: Math.round(item.actual_energy * 10) / 10,
      predicted: Math.round(item.predicted_energy * 10) / 10,
      lower: Math.round(item.confidence_lower * 10) / 10,
      upper: Math.round(item.confidence_upper * 10) / 10
    })), [data]);

  return (
    <div className="w-full h-64 bg-gradient-to-br from-slate-50 to-white rounded-xl border border-slate-200 p-4">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={chartData}>
          <CartesianGrid strokeDasharray="2 2" stroke="#e2e8f0" opacity={0.3} />
          <XAxis 
            dataKey="time" 
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 12, fill: '#64748b' }}
          />
          <YAxis 
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 12, fill: '#64748b' }}
          />
          <Tooltip />
          <Area
            type="monotone"
            dataKey="upper"
            stackId="1"
            stroke="none"
            fill="rgba(99, 102, 241, 0.1)"
          />
          <Area
            type="monotone"
            dataKey="lower"
            stackId="1"
            stroke="none"
            fill="rgba(255, 255, 255, 1)"
          />
          <Line type="monotone" dataKey="predicted" stroke="#6366f1" strokeWidth={3} dot={false} name="Predicted" />
          <Line type="monotone" dataKey="actual" stroke="#10b981" strokeWidth={2} dot={false} name="Actual" />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PredictionChart;